import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import Font from '@ckeditor/ckeditor5-font/src/font.js';
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption.js';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize.js';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload.js';
import Indent from '@ckeditor/ckeditor5-indent/src/indent.js';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import PageBreak from '@ckeditor/ckeditor5-page-break/src/pagebreak.js';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough.js';
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties.js';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties.js';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import TableColumnResize from '@ckeditor/ckeditor5-table/src/tablecolumnresize';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation.js';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline.js';

import { ClassicEditor as ClassicEditorBase } from '@ckeditor/ckeditor5-editor-classic';

// Import our custom build of the cloud editor
import CKEditorCS from './ckeditor.js';


/**
 * Why do we need a super build?
 * 
 * This enables us to use multiple custom (or standard) editors in our webapp.
 * In our case, we are now using a standard (offline) ClassicEditor, as well as our
 * long-standing cloud services enabled editor CKEditorCS.
 * 
 * We must keep the CKEditorCS definition separate, so that we can upload only that build
 * to CK-CS, and not the entire super build.
 * 
 * In the webapp, you can now access an editor by import ie:
 * import Editors from 'ckeditor5-custom-build/build/ckeditor-superbuild.js';
 * and then you can choose:
 * Editors.ClassicEditor or Editors.CKEditorCS
 */

class ClassicEditor extends ClassicEditorBase {}
ClassicEditor.builtinPlugins = [
  Essentials,
  Autoformat,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Heading,
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  Font,
  Alignment,
  Paragraph,
  Indent,
  IndentBlock,
  ImageUpload,
  PageBreak,
  Table,
  TableCellProperties,
  TableProperties,
  TableToolbar,
  TableColumnResize,
  TextTransformation,
];

ClassicEditor.defaultConfig = {
  language: 'en',
  licenseKey: 'ZDRkZ0wzUzdVTTFNTlNvb1B4ajJubXp6L25QaGdkY200L2Z3cloxZ0FRcjJ3UUdiV2hJSS1NakF5TkRBNE1qZz0=',
  toolbar: {
    items: [
      'fontSize',
      'fontFamily',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'imageUpload',
      '|',
      'alignment',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'outdent',
      'indent',
      'insertTable',
    ]
  },
  image: {
    toolbar: [],
    insert: {
      type: 'inline',
    },
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells',
      'tableProperties',
      'tableCellProperties',
    ],
    tableToolbar: ['comment'],
  },
  link: {
    decorators: {
      openInNewTab: {
        mode: 'manual',
        label: 'Open in a new tab',
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      },
    },
    defaultProtocol: 'http://',
  },
  indentBlock: {
    offset: 1,
    unit: 'em',
  },
  fontSize: {
    options: [9, 10, 12, 14, 16, 20, 24, 28, 32],
    supportAllValues: true,
  },
  fontFamily: {
    options: [
      'default',
      'Arial, Helvetica, sans-serif',
      'Courier New, Courier, monospace',
      'Georgia, serif',
      'Lucida Sans Unicode, Lucida Grande, sans-serif',
      'Tahoma, Geneva, sans-serif',
      'Times New Roman, Times, serif',
      'Trebuchet MS, Helvetica, sans-serif',
      'Verdana, Geneva, sans-serif',
    ],
  },
  list: {
    properties: {
      styles: true,
      startIndex: true,
      reversed: true,
    },
  },
};

// If adding more editors to the super build, they must be exported here
export default {
  ClassicEditor,
  CKEditorCS
};
